<template>
    <v-card
        @click="openGoodPractice()"
        class="good-practice-card"
        elevation="0"
    >
        <v-card-text class="pa-0 pa-md-3">
            <v-row class="align-start my-0">
                <v-col class="col-9 col-md-10 py-0">
                    <h2 class="text-h5 mb-2 primary--text">
                        {{ goodPractice.title }}
                    </h2>
                    <p class="mb-2 font-weight-medium">{{ goodPractice.projectGroup }}</p>
                    <p class="text--secondary mb-0" style="white-space: pre-line;">{{ truncatedDescription }}</p>
                </v-col>
                <v-col class="col-3 col-md-2 py-0 my-auto text-right">
                    <v-btn
                        fab
                        color="primary"
                        dark
                        elevation="0"
                    >
                        <v-icon>
                            fas fa-angle-double-right
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "GoodPracticeCard",
    props: {
        goodPractice: {
            type: Object,
            required: true,
        },
    },
    computed: {
        truncatedDescription() {
            if (this.goodPractice.description && this.goodPractice.description.length > 150) {
                return this.goodPractice.description.substring(0, 150) + '...';
            }
            return this.goodPractice.description;
        },
    },
    methods: {
        openGoodPractice() {
            this.$router.push({name: 'GoodPractice', params: {uuid: this.goodPractice.uuid}});
        },
    },
}
</script>
